import firebase from "../store/api/firebaseAdmin";

export const getFirebaseInstance = () => firebase.firestore();
